export default "__VITE_ASSET__vnHXt8dU__"